import ActionTypes from '../../constants/ActionTypes'
import ENV from '../../env'

export const requestFetchPageShell = (lang) => (dispatch, getState, container) => {
  dispatch({
    type: ActionTypes.HEADER_FOOTER.FETCH_PAGE_SHELL_REQUEST,
    payload: {
      data: ''
    }
  });

  let siteUrl = `${ENV.api.site_base_url}/${lang}${ENV.api.siteHeaderEndpoint}`;
  let bffUrl = `${ENV.api.base_url}${ENV.api.headerEndpoint}`;

  container.http.get(siteUrl).then((response) => {
    dispatch(receivePageShell(response.data));
  }, (error) => {
    console.log(error);
  })

  container.http.get(bffUrl).then((response) => {
    dispatch(setSessionData(response.data.session))
    if (response.data.session.redirectUser) {
      dispatch(setShouldCallLogin(true));
    }

  }, (error) => {
    console.log(error);
  })
}

function receivePageShell(pageShell) {
  return {
    type: ActionTypes.HEADER_FOOTER.FETCH_PAGE_SHELL_SUCCESS,
    payload: {
      pageShell: pageShell.pageData
    },
  }
}

export const setProfileFromTnAccount = (accessToken, from) => (dispatch, getState, container) => {
  dispatch({
    type: ActionTypes.SESSION_DATA.GET,
  })

  const setProfileParams = {
    accessToken: accessToken.accessToken,
    refreshToken: accessToken.refreshToken,
    expires: accessToken.expires,
    tokenType: accessToken.tokenType
  };

  container.http.post(`${ENV.api.base_url}${ENV.api.loginEndpoint}`, null, setProfileParams).then((response) => {
    dispatch(setSessionData(response.data.session));
    window.location.replace(from);
  }, (error) => {
    console.log(error);
    window.location.replace(from);
  })
};

function setSessionData(sessionData) {
  return {
    type: ActionTypes.SESSION_DATA.SET,
    payload: sessionData,
  }
}


export function setShouldCallLogin(value) {
  return {
    type: ActionTypes.SESSION_DATA.SHOULD_CALL_LOGIN,
    payload: value,
  }
}

export const logoutFromTnAccount = () => (dispatch, getState, container) => {
  dispatch({
    type: ActionTypes.AUTH.LOGOUT_FROM_TN_ACCOUNT,
    payload: {
      data: ''
    }
  });

  const prefixUrl = ENV.prefixUrl ? ENV.prefixUrl : '';

  container.http.del(`${ENV.api.base_url}${ENV.api.logoutEndpoint}`, null, "").then((response) => {
    dispatch(setSessionData(response.data.session))
    window.location.replace(`${ENV.tnAccountDomain}/app/logout?post_logout_redirect_uri=${ENV.domain + prefixUrl}`);
  }, (error) => {
    console.log(error);
    window.location.replace(ENV.root_path + prefixUrl);
  })
}



